<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-center justify-between">
            <div data-cy="claimants-title">{{ $t('admin.claimants.title') }}</div>
            <div class="flex flex-col">
                <a-dropdown :trigger="['click']" class="shadow-none" data-cy="claimant-export-dropdown">
                    <a-button style="margin-left: 8px">
                        {{ $t('claims.claimants.export.title') }}
                        <DownOutlined />
                    </a-button>
                    <template #overlay>
                        <a-menu @click="onSelectClick">
                            <a-menu-item data-cy="claimant-export-select" key="ExportClaimant">
                                <DownloadOutlined />
                                {{ $t('claims.claimants.export.button') }}
                            </a-menu-item>
                        </a-menu>
                    </template>
                </a-dropdown>
            </div>
        </div>
        <admin-claimants-table ref="ClaimantsTable" :section_type="section_type" @onTableAction="onTableAction" />
        <a-drawer
            data-cy="claimant-drawer"
            title="Claimant Details"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <view-claimant
                data-cy="claimant-view"
                :claimant="claimant"
                :section_type="section_type"
                form_mode="drawer"
                @onDrawerClose="onClose"
            />
        </a-drawer>
    </div>
</template>

<script>
import AdminClaimantsTable from '@/components/tables/Claimants.vue';
import ViewClaimant from '@/components/views/claimants/Default.vue';

import FileManager from '@/utils/file.js';
import { DownloadOutlined, DownOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        AdminClaimantsTable,
        ViewClaimant,
        DownloadOutlined,
        DownOutlined,
    },
    props: {
        association_id: {
            type: String,
            default: '',
        },
        company_id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            claimant: {},
            drawer_visible: false,
            drawer_form_dirty: false,
            processing: false,
        };
    },
    computed: {
        section_type() {
            if (
                (this.association_id === '' || this.association_id === undefined || this.association_id === null) &&
                (this.company_id === '' || this.company_id === undefined || this.company_id === null)
            ) {
                return 'site_admin';
            } else if (this.company_id === '' || this.company_id === undefined || this.company_id === null) {
                return 'association';
            } else {
                return 'company';
            }
        },
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        openDrawer(id) {
            let url = '/api/admin/claimants/' + id;

            if (this.section_type == 'association') {
                url = '/api/associations/claimants/' + id;
            }

            if (this.section_type == 'company') {
                url = '/api/companies/claimants/' + id;
            }
            this.$http
                .get(url)
                .then((response) => {
                    let claimantData = {
                        ...response.data.data,
                    };

                    this.claimant = claimantData;
                    this.drawer_visible = true;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.404'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCVIEW03' }),
                        });
                    }
                });
        },
        onTableAction(data) {
            switch (data.key) {
                case 'view':
                    this.openDrawer(data.id);
                    break;
            }
        },
        onClose() {
            this.drawer_visible = false;
        },
        onSelectClick(event) {
            switch (event.key) {
                case 'ExportClaimant':
                    this.onExport();
                    break;
            }
        },
        onExport() {
            if (this.processing) {
                return false;
            }

            let url = '/api/admin/claimants/export';

            if (this.section_type == 'association') {
                url = '/api/associations/claimants/export';
            }

            let data = this.$refs.ClaimantsTable.params;

            this.$http
                .post(url, { ...data })
                .then((response) => {
                    if (
                        _.includes(
                            [
                                'text/csv; charset=UTF-8',
                                'text/csv; charset=utf-8',
                                'text/plain; charset=UTF-8',
                                'text/plain; charset=utf-8',
                            ],
                            response.headers['content-type'],
                        )
                    ) {
                        this.$notification.success({ message: this.$t('claims.notifications.success.export') });

                        FileManager.download(response);
                    } else {
                        this.$notification.error({ message: response.data.message });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        // todo: add message here
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVEXC01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        reload() {
            this.$refs.ClaimantsTable.reload();
        },
    },
};
</script>
